import usePromiseInstance_authorization from "./config";
import { getAllCompanyInfoList_failure, getAllCompanyInfoList_requesting, getAllCompanyInfoList_success, getCompanyInfoList_failure, getCompanyInfoList_requesting, getCompanyInfoList_success, getCompanyInfoOptionLists_failure, getCompanyInfoOptionLists_requesting, getCompanyInfoOptionLists_success } from "dataflow/billingPortal/slices/companyInfo.slices";
import { func_serviceHandling, isNumberValid } from "functions";
import { useDispatch } from "react-redux";

export default function useCompanyInfoActions() {
    const dispatch = useDispatch();
    const request = usePromiseInstance_authorization();

    function getCompanyInfoList(pageNo, pageSize, sort, filterOptions) {
        dispatch(getCompanyInfoList_requesting());
    
        let isOffsetValid = isNumberValid(pageNo) && isNumberValid(pageSize);
        let offset = isOffsetValid? pageNo * pageSize:0;
    
        let paramObj = {
            offset: offset,
            limit: pageSize,
            sort: sort,
            validCom: filterOptions?.validCom,
            userInCom: filterOptions?.userInCom,
            ...(filterOptions?.filters)
        }
    
        let url = func_serviceHandling.createUrlWithParams('/ComInfo/ComInfoTools/GetComInfo', paramObj);
    
        request(getCompanyInfoList_requesting, (axios) => {
            axios.get(url)
                .then(function (details) {
                    // handle success
                    dispatch(getCompanyInfoList_success(details));
                })
                .catch(function (error) {
                    // handle error
                    dispatch(getCompanyInfoList_failure(error));
                })
                .finally(function () {
                    // always executed
                });
        });
    }
    
    
    
    function getAllCompanyInfoList() {
        dispatch(getAllCompanyInfoList_requesting());
    
        request(getAllCompanyInfoList_requesting, (axios) => {
            axios.post('/ComInfo/ComInfoTools/GetComInfo?limit=0', {})
                .then(function (details) {
                    // handle success
                    dispatch(getAllCompanyInfoList_success(details));
                })
                .catch(function (error) {
                    // handle error
                    dispatch(getAllCompanyInfoList_failure(error));
                })
                .finally(function () {
                    // always executed
                });
        });
    }
    
    function getCompanyInfoOptionLists() {
        dispatch(getCompanyInfoOptionLists_requesting());
    
        request(getCompanyInfoOptionLists_requesting, (axios) => {
            axios.get('/ComInfo/ComInfoTools/GetCompFilters', {})
                .then(function (details) {
                    // handle success
                    dispatch(getCompanyInfoOptionLists_success(details));
                })
                .catch(function (error) {
                    // handle error
                    dispatch(getCompanyInfoOptionLists_failure(error));
                })
                .finally(function () {
                    // always executed
                });
        });
    }

    return {
        getCompanyInfoList,
        getAllCompanyInfoList,
        getCompanyInfoOptionLists,
    }
}